import { useEffect, useState } from "react";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetFeatureWFSQuery } from "../../../api/rtk/mapWFS/slices/mapWFSApiSlice";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { getGeoJSONFeaturesVectorLayer, getAllObjectsLayer } from "../../../widgets/map/mapFeatures/layers";
import { countExtentFromGeoJSONFeatures } from "../../../widgets/map/mapFeatures/helpers";
import LoaderWrapper from "../../../widgets/loaderWrapper/LoaderWrapper";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";
import { useDispatch } from "react-redux";
import ToastMessageContainer from "../../../widgets/toastMessageContainer/ToastMessageContainer";
import { setMapPathEnding, setMapPathPosition, setMapPathValue } from "../../../stateManagement/reducers/maps/MapPathSlice";
import { showToastMessage } from "../../../stateManagement/reducers/ToastMessageSlice";

export function MapPath() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [fitExtent, setFitExtent] = useState<any>();
    const [fitExtentPadding, setFitExtentPadding] = useState<any>([]);
    const [mapTitle, setMapTitle] = useState<string>('');
    const [getFeatureWFS, { isLoading, isError }] = useLazyGetFeatureWFSQuery()
    const { pathId } = useParams();

    const roadsLayer = getAllObjectsLayer()
    const permanentLayers: any = [roadsLayer]

    async function getPath() {
        const { workspace } = getItemWebStorage('currentConfig')
        const cqlFilter = `PathID = ${pathId}`
        const { data: pathGeoJSON, isSuccess } = await getFeatureWFS({ workspace, layer: 'MALink', cqlFilter })
        if (isSuccess) {
            if (!pathGeoJSON?.features?.length) {
                navigate('/app/error')
            } else {
                const { RoadName: roadName, PathName: pathName, RoadID: roadId } = pathGeoJSON.features[0].properties
                setMapTitle(`Карта «${roadName} ${pathName}»`)
                dispatch(setMapPathValue({ pathName, pathId, roadName, roadId }))
                getPathPositionAndEnding(pathGeoJSON)
                const pathLayer = getGeoJSONFeaturesVectorLayer(pathGeoJSON, "EPSG:3857")
                setAdditionalLayers([pathLayer])
                const extent = countExtentFromGeoJSONFeatures(pathGeoJSON, true)
                setFitExtent(extent)
                setFitExtentPadding([50, 50, 50, 50])
            }
        }
    }

    function getPathPositionAndEnding(pathGeoJSON: any) {
        const minPosition = Math.min(...pathGeoJSON.features.map((o: any) => o.properties.Position))
        const maxEnding = Math.max(...pathGeoJSON.features.map((o: any) => o.properties.Ending))
        if (minPosition) {
            dispatch(setMapPathPosition(minPosition.toFixed(3)))
        }
        if (maxEnding) {
            dispatch(setMapPathEnding(maxEnding.toFixed(3)))
        }
    }

    useEffect(() => {
        getPath()
        return () => {
            dispatch(setMapPathValue(null))
        }
    }, [])

    useEffect(() => {
        if (isError) {
            dispatch(showToastMessage({ messageText: "Не удалось загрузить карту направления", messageType: "error" }))
        }
    }, [isError])

    return (
        <>
            <ContentHeader title={mapTitle} type="map" option="path" />
            <div className="map-widget-with-toast">
                <ToastMessageContainer />
                <LoaderWrapper isLoading={isLoading} >
                    <MapWidget additionalLayers={additionalLayers} permanentLayers={permanentLayers} propsFitExtent={fitExtent} propsFitExtentPadding={fitExtentPadding} />
                </LoaderWrapper>
            </div>
        </>
    )
}
